

















































import Vue from 'vue'

export default Vue.extend({
  name: 'AppDialogPrompt',
  props: {
    message: {
      required: true,
      type: String
    },
    triggerOpenDialog: {
      required: true,
      type: Boolean
    },
    isFieldRequired: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dialog: false,
      text: ''
    }
  },
  watch: {
    triggerOpenDialog (val: boolean) {
      // Watching the changes of properties which passed from the parent component (some flag - boolean type) 
      // and assign to local prop "dialog" for displaying the dialog window
      this.dialog = val
    },
    dialog (val: boolean) {
      if (!val) {
        this.$emit('cancelAction')
        this.clear()
      }
    }
  },
  methods: {
    send () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.$validator.reset()
            this.$emit('confirmAction', this.text)
            this.clear()
          }
        })
    },
    clear () {
      this.text = ''
    }
  }
})
